import React, { createContext, useState, useEffect, useContext } from 'react';

const PWAInstallContext = createContext(null);

export const usePWAInstall = () => {
  const context = useContext(PWAInstallContext);
  if (context === null) {
    return { canInstall: false, triggerInstall: () => {} };
  }
  return context;
};

export const PWAInstallProvider = ({ children }) => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [canInstallFallback, setCanInstallFallback] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isInstalled = isStandalone || window.navigator.standalone;

    if (!isInstalled) {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isChrome = /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);
      const isEdge = /Edg/.test(navigator.userAgent);
      const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      
      const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      
      if (isChrome || isEdge || (isMobile && (isChrome || isSafari)) || isDev) {
        setTimeout(() => {
          if (!installPrompt) {
            setCanInstallFallback(true);
          }
        }, isDev ? 1000 : 3000);
      }
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [installPrompt]);

  const triggerInstall = async () => {
    if (installPrompt) {
      try {
        installPrompt.prompt();
        const { outcome } = await installPrompt.userChoice;
        
        setInstallPrompt(null);
        setCanInstallFallback(false);
      } catch (error) {
        console.error('PWA installation error:', error);
      }
    } else if (canInstallFallback) {
      const userAgent = navigator.userAgent.toLowerCase();
      let instructions = '';
      
      if (userAgent.includes('chrome') && userAgent.includes('mobile')) {
        instructions = '1. Tap menu (⋮) → "Add to Home Screen"\n2. Tap "Install" to confirm';
      } else if (userAgent.includes('chrome')) {
        instructions = '1. Look for install icon in address bar\n2. Or Chrome menu → "Install Terriqon"\n3. Click "Install"';
      } else {
        instructions = 'Look for "Install" option in browser menu';
      }
      
      alert(`Install Terriqon app:\n\n${instructions}`);
    }
  };

  return (
    <PWAInstallContext.Provider value={{ canInstall: !!installPrompt || canInstallFallback, triggerInstall }}>
      {children}
    </PWAInstallContext.Provider>
  );
};

export default PWAInstallContext;